import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import React, { CSSProperties, useState } from 'react';
import { StyledSVGButton } from '@/styles/GlobalStyles';
import SvgImage from '@/components/Module/SvgImage';

type P = {
  errorCode?: string;
  errorMessage?: string;
  refresh?: () => void;
  style?: CSSProperties;
};
const ErrorMessage = ({ errorMessage, errorCode, refresh, style }: P) => {
  const [isRotating, setIsRotating] = useState(false);

  const handleRefresh = () => {
    setIsRotating(true);
    refresh?.();
    setTimeout(() => setIsRotating(false), 600);
  };

  return (
    <CenterLayout style={style}>
      <div>{errorCode ?? ''}</div>
      <div style={{ whiteSpace: 'pre-wrap', textAlign: 'center' }}>
        {errorMessage ??
          '네트워크 연결 상태가 좋지 않습니다.\n잠시 후 다시 시도해 주세요.'}
      </div>
      {refresh && (
        <RotatingButton onClick={handleRefresh} isRotating={isRotating}>
          <SvgImage name={'refresh'} />
        </RotatingButton>
      )}
    </CenterLayout>
  );
};
export default ErrorMessage;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const RotatingButton = styled(StyledSVGButton)<{ isRotating: boolean }>`
  svg {
    ${({ isRotating }) =>
      isRotating && `animation: ${rotate.name} 0.6s ease-in-out;`}
  }
`;

const CenterLayout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: calc(100vh - 400px);
  align-items: center;
  gap: 12px;
  width: 100%;
  color: #888d96;
`;
